import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { RestWorkflowStepCommentModel } from '@shared/interfaces/comments.interface';

@Injectable({
  providedIn: 'root',
})
export class WorkflowStepCommentsService {
  constructor(private restApiService: RestapiService) {}

  create(comment: RestWorkflowStepCommentModel): Observable<RestWorkflowStepCommentModel> {
    return this.restApiService.create<RestWorkflowStepCommentModel>(`WorkflowStepComments`, comment);
  }

  update(comment: RestWorkflowStepCommentModel): Observable<RestWorkflowStepCommentModel> {
    return this.restApiService.update<RestWorkflowStepCommentModel>(`WorkflowStepComments/${comment.id}`, comment);
  }

  delete(commentId: number): Observable<unknown> {
    return this.restApiService.delete<unknown>(`WorkflowStepComments/${commentId}`);
  }

  getWorkflowStepComments(turnoverId: number): Observable<RestWorkflowStepCommentModel[]> {
    return this.restApiService.getData<RestWorkflowStepCommentModel[]>(`WorkflowStepComments/turnover/${turnoverId}`);
  }

  addReaction(commentId: number, reactionId: string): Observable<RestWorkflowStepCommentModel> {
    return this.restApiService.post<RestWorkflowStepCommentModel>(
      `WorkflowStepComments/${commentId}/AddReaction?reactionId=${encodeURIComponent(reactionId)}`,
      {}
    );
  }

  deleteReaction(commentId: number, reactionId: string): Observable<RestWorkflowStepCommentModel> {
    return this.restApiService.post<RestWorkflowStepCommentModel>(
      `WorkflowStepComments/${commentId}/DeleteReaction?reactionId=${encodeURIComponent(reactionId)}`,
      {}
    );
  }
}
